<template>
  <q-layout view="lHh Lpr lFf">
    <Header />
    <q-page-container>
      <q-page padding>
        <div class="row q-pt-lg text-grey-9">
          <div class="col"></div>
          <div class="col-5" style="max-width: 400px">
            <span class="text-h5">Changement de mot de passe</span>
            <q-separator class="q-mt-sm q-mb-lg"/>
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
              <q-form
                @submit.prevent="handleSubmit(onSubmit)"
                class="q-pt-sm"
              >
                <ValidationProvider
                  name="password"
                  ref="password"
                  mode="passive"
                  rules="required|password"
                  v-slot="{ errors, invalid, validated }"
                >
                  <q-input
                    v-model="password"
                    label="Nouveau mot de passe"
                    type="password"
                    color="grey-9"
                    clearable
                    filled
                    :error="invalid && validated"
                    :error-message="errors[0]"
                    class="q-mb-md"
                    @input="resetFieldErrors('confirmPassword')"
                  />
                </ValidationProvider>
                <ValidationProvider
                  name="confirmPassword"
                  ref="confirmPassword"
                  mode="passive"
                  rules="required|confirmPassword:@password"
                  v-slot="{ errors, invalid, validated }"
                >
                  <q-input
                    v-model="confirmPassword"
                    label="Répétez le nouveau mot de passe"
                    type="password"
                    color="grey-9"
                    clearable
                    filled
                    :error="invalid && validated"
                    :error-message="errors[0]"
                    class="q-mb-md"
                    @input="resetFieldErrors('confirmPassword')"
                  />
                </ValidationProvider>
                <div>
                  <q-btn
                    label="Changer le mot de passe"
                    v-bind:disable="isSubmit"
                    type="submit"
                    class="text-white bg-grey-9"
                  />
                </div>
              </q-form>
            </ValidationObserver>
          </div>
          <div class="col"></div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { FormMixin } from '~/mixins';
import Header from '~/components/Header';
import { resetPassword, confirmResetPassword } from '~/services/user';
import { handleGlobalErrors } from '~/services/errors';
import { notifySuccess } from '~/services/notify';

export default {
  mixins: [FormMixin],
  components: {
    Header,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      id: this.$route.params.id,
      token: this.$route.params.token,
      password: '',
      confirmPassword: ''
    };
  },
  beforeMount: async function() {
    const resp = await resetPassword(this.id, this.token);
    if (resp.status != 200) {
      handleGlobalErrors(resp);
      this.$router.push({name: 'Page404'});
    }
  },
  methods: {
    async onSubmit() {
      const response = await confirmResetPassword(
        this.id, this.token, this.password, this.confirmPassword
      ).then((response) => {
        if (response.status != 200) {
          this.$refs.form.setErrors(response.data.errors);
        } else {
          notifySuccess(response.data.status);
          this.$router.push({name: 'login'})
        }
      });
    }
  }
};
</script>
